// export default EditRdvStandart;
import React, { useState, useEffect, useRef } from "react";
import { Offcanvas, Button, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { updateRendezVous } from "../../store/slices/rendezVousSlice";
import { useDispatch } from "react-redux";
import { fetchCalendarData } from "../../store/slices/rendezVousPrestaSlice";
import {
  toFrenchTimeUTC,
  parseDateUTC,
  parseToISOString,
  InverseparseDateFromDDMMYY,
  datewithTiret,
} from "../../utils/utils";
import { useSelector } from "react-redux";
import { useLoadScript } from "@react-google-maps/api";
import LocationAutocomplete from "../LocationAutocomplete";
import { format } from "date-fns";

function EditRdvStandart({ show, handleClose, ...props }) {
  const libraries = ["places"];
  const rendezVous = props?.event;
  // console.log("rendezVous", rendezVous);

  const { allEtablissementEquipes } = useSelector((state) => state.rdvPresta);
  // console.log("allEtablissementEquipes:", allEtablissementEquipes);
  const [lieuSelectionne, setLieuSelectionne] = useState(
    rendezVous?.lieu_intervention || ""
  );
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  useEffect(() => {
    dispatch(fetchCalendarData());
  }, [dispatch]);

  const handleLocationSelect = (
    place,
    setFieldValue,
    setFieldTouched,
    fieldName
  ) => {
    const address = place?.description || "";
    // console.log("address:", place?.description);
    setFieldValue(fieldName, address);
    setFieldTouched(fieldName, true);
    if (isLoaded && window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
    }
  };

  const handleSubmit = (values, { setSubmitting }) => {
    const formattedDate = datewithTiret(values?.date);

    const start_time = `${formattedDate} ${values?.start_time}:00`;
    const end_time = `${formattedDate} ${values?.end_time}:00`;

    const updatedRdv = {
      id: rendezVous?.id,
      ...values,
      date: values?.date,
      start_time,
      end_time,
      lieu_intervention: values?.lieu_intervention,
      ...(values.lieu_intervention === "onsite" && {
        adresse_domicile: values.adresse_domicile,
      }),
      ...(values.lieu_intervention === "enligne" && {
        meeting_link: values.meeting_link,
      }),
    };

    dispatch(updateRendezVous(updatedRdv))
      .unwrap()
      .then(() => {
        dispatch(fetchCalendarData());
        toast.success("Rendez-vous modifié avec succès");
        setSubmitting(false);
        handleClose(); // Fermer le Offcanvas après succès
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setSubmitting(false);
      });
  };

  useEffect(() => {
    setLieuSelectionne(rendezVous?.lieu_intervention || "");
  }, [rendezVous?.lieu_intervention]);
  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Champ requis"),
    date: Yup.string()
      .required("Champ requis")
      .test(
        "is-today-or-future",
        "La date ne peut pas être dans le passé",
        function (value) {
          if (!value) return false;

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const selected = InverseparseDateFromDDMMYY(value);
          selected.setHours(0, 0, 0, 0);

          return selected >= today;
        }
      ),

    start_time: Yup.string()
      .required("Champ obligatoire")
      .test(
        "start-time-not-in-past",
        "L'heure de début ne peut pas être dans le passé",
        function (value) {
          const { date } = this.parent;
          if (!date || !value) return true;

          const today = new Date();

          const selectedDate = InverseparseDateFromDDMMYY(date);

          if (selectedDate.toDateString() === today.toDateString()) {
            const [hours, minutes] = value.split(":");
            const selectedStartTime = new Date(selectedDate);
            selectedStartTime.setHours(Number(hours), Number(minutes), 0, 0);

            return selectedStartTime > today;
          }

          return true;
        }
      ),

    end_time: Yup.string()
      .required("Champ obligatoire")
      .test(
        "is-after-start",
        "L'heure de fin doit être supérieure à l'heure de début",
        function (value) {
          const { start_time } = this.parent;
          if (!start_time || !value) return true;
          return value > start_time;
        }
      ),

    lieu_intervention: Yup.string().required("Champ requis"),
    meeting_link: Yup.string().when("lieu_intervention", {
      is: "enligne",
      then: (schema) => schema.required("Champ requis").url("Lien invalide"),
      otherwise: (schema) => schema.notRequired(),
    }),
    adresse_domicile: Yup.string().when("lieu_intervention", {
      is: "onsite",
      then: (schema) => schema.required("Champ requis"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="agenda"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="agendaTiltle">
          Modifier un rendez-vous
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Formik
          innerRef={formikRef}
          initialValues={{
            title:
              rendezVous?.title ||
              rendezVous?.prestations_snapshot[0] ||
              "",
            date: rendezVous?.start_time
              ? dayjs(rendezVous?.start_time).format("DD/MM/YY")
              : "",
            start_time: toFrenchTimeUTC(parseDateUTC(rendezVous?.start_time)),
            end_time: toFrenchTimeUTC(parseDateUTC(rendezVous?.end_time)),
            equipe_id: rendezVous?.equipe_id || "",
            lieu_intervention: rendezVous?.lieu_intervention || "",
            meeting_link: rendezVous?.meeting_link || "",
            adresse_domicile: rendezVous?.adresse_domicile || "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
          }) => (
            <Form onSubmit={handleSubmit} className="m-24">
              <Form.Group className="mb-3">
                <Form.Label className="legend">
                  Titre du rendez-vous*
                </Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.title && !!errors.title}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.title}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-flex">
                <Form.Group className="mb-3 w-30 m-4">
                  <Form.Label className="legend">Date*</Form.Label>
                  <Form.Control
                    name="date"
                    value={values.date}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.date && !!errors.date}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.date}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 w-30 m-4">
                  <Form.Label className="legend">De*</Form.Label>
                  <Form.Control
                    name="start_time"
                    value={values.start_time}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.start_time && !!errors.start_time}
                    type="time"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.start_time}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 w-30 m-4">
                  <Form.Label className="legend">À*</Form.Label>
                  <Form.Control
                    name="end_time"
                    value={values.end_time}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.end_time && !!errors.end_time}
                    type="time"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.end_time}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              <Form.Group className="mb-3">
                <Form.Label className="legend">Salarié</Form.Label>
                <Form.Select
                  name="equipe_id"
                  value={values.equipe_id}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.equipe_id && !!errors.equipe_id}
                >
                  <option value="all">Choisir un salarié</option>
                  {allEtablissementEquipes?.map((employee) => (
                    <option key={employee.id} value={employee.id}>
                      {employee.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.equipe_id}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="legend">Lieu d'intervention</Form.Label>
                <Form.Select
                  name="lieu_intervention"
                  value={values.lieu_intervention}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setLieuSelectionne(selected);
                    handleChange(e);
                  }}
                  disabled
                  onBlur={handleBlur}
                  isInvalid={
                    touched.lieu_intervention && !!errors.lieu_intervention
                  }
                >
                  <option value="" disabled selected>
                    Sélectionnez un lieu d'intervention
                  </option>
                  <option value="chezpro">Chez le professionnel</option>
                  <option value="onsite">À domicile</option>
                  <option value="enligne">En ligne</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.lieu_intervention}
                </Form.Control.Feedback>
              </Form.Group>

              {lieuSelectionne === "enligne" && (
                <Form.Group className="mb-3">
                  <Form.Label className="legend">
                    Lien de la visioconférence*
                  </Form.Label>
                  <Form.Control
                    type="url"
                    name="meeting_link"
                    value={values.meeting_link}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.meeting_link && !!errors.meeting_link}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.meeting_link}
                  </Form.Control.Feedback>
                </Form.Group>
              )}

              {lieuSelectionne === "onsite" && (
                <div className="input-wrapper form-group mt-16">
                  <label className="form-label">Adresse du client*</label>
                  <div className="relative">
                    <LocationAutocomplete
                      onLocationSelect={(place) =>
                        handleLocationSelect(
                          place,
                          setFieldValue,
                          setFieldTouched,
                          "adresse_domicile"
                        )
                      }
                      isGoogleLoaded={isLoaded}
                      value={values.adresse_domicile}
                    />
                  </div>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </Offcanvas.Body>
      <div className="offcanvas-footer mb-24">
        <div className="container plr24">
          <div className="mt-4 w-30">
            <Button
              onClick={() => {
                if (formikRef.current) {
                  formikRef?.current?.submitForm();
                }
              }}
              type="submit"
              variant="primary"
              className="twyny-cta-primary padding-submit width-100"
              // disabled={isSubmitting}
            >
              Modifier le rendez-vous
            </Button>
          </div>

          <div className="mt-4 w-30 mt-8">
            <Button
              variant="secondary"
              onClick={handleClose}
              className="twyny-cta-secondary padding-submit width-100"
            >
              Annuler
            </Button>
          </div>
        </div>
      </div>
    </Offcanvas>
  );
}

export default EditRdvStandart;
